import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/HomePage';
import FolderPage from './pages/FolderPage';
import MyFilesPage from './pages/MyFilesPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import DMCAPolicy from './pages/DMCAPolicy';
import Blog from './pages/Blog';
import WeTransferAlternative from './pages/WeTransferAlternative';
import Send10GBFiles from './pages/Send10GBFiles';
import ContactForm from './pages/ContactForm';
import AdminPage from './pages/AdminPage';
import Profile from './pages/Profile';
import PricingPage from './pages/PricingPage';
import Sidebar from './components/Sidebar';
import './App.css';

// Initialize user ID on app load
function initializeUserId() {
  const KEY = 'fileshare_user_id';
  const ORIGINAL_KEY = 'fileshare_original_user_id';
  
  let userId = localStorage.getItem(KEY);
  
  // If no user ID, check if we have original ID
  if (!userId) {
    const originalId = localStorage.getItem(ORIGINAL_KEY);
    if (originalId) {
      // Restore from original
      localStorage.setItem(KEY, originalId);
      userId = originalId;
      console.log(`✅ Restored user ID from original: ${userId}`);
    } else {
      // Create new UUID
      const newId = `user_${crypto.randomUUID()}`;
      localStorage.setItem(KEY, newId);
      localStorage.setItem(ORIGINAL_KEY, newId);
      userId = newId;
      console.log(`🆕 Created new user ID: ${userId}`);
    }
  } else {
    console.log(`✅ User ID already exists: ${userId}`);
  }
  
  return userId;
}

function AppContainer() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  // Initialize user ID on mount
  useEffect(() => {
    initializeUserId();
  }, []);

  return (
    <div className="App min-h-screen" style={{ 
      backgroundColor: isAdminRoute ? '#f8f9fa' : '#1a1d29',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      color: isAdminRoute ? '#202124' : '#e2e8f0'
    }}>
      {!isAdminRoute && <Sidebar />}
      
      {/* Main Content Area with responsive padding */}
      <div style={{
        marginLeft: '0px',
        paddingTop: isAdminRoute ? '0px' : '50px'
      }} className={isAdminRoute ? '' : 'md:ml-[220px] md:pt-0'}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/uploads" element={<MyFilesPage />} />
          <Route path="/d/:folderId" element={<FolderPage />} />
          <Route path="/r/:folderId" element={<FolderPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/dmca-policy" element={<DMCAPolicy />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/wetransfer-alternative" element={<WeTransferAlternative />} />
            <Route path="/send-10gb-files" element={<Send10GBFiles />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContainer />
      </Router>
    </AuthProvider>
  );
}

export default App;
